import React, { Component } from "react";
import "./App.css";
import "react-select/dist/react-select.css";
import $ from "jquery";
import { loadStores, loadDisccounts } from "./service/service";
import { setMapTopOffset } from "./utils/calc";
import StartView from "./views/StartView";
import MapView from "./views/MapView";
import config from "./mp-config"

import pld_p0 from "../assets/planos/pld/p0.json"
import pld_p1 from "../assets/planos/pld/p1.json"
import pld_p2 from "../assets/planos/pld/p2.json"
import pld_p3 from "../assets/planos/pld/p3.json"

import peg_p0 from "../assets/planos/peg/p0.json"
import peg_p1 from "../assets/planos/peg/p1.json"
import peg_p2 from "../assets/planos/peg/p2.json"
import peg_p3 from "../assets/planos/peg/p3.json"
import peg_p4 from "../assets/planos/peg/p4.json"
import peg_pm1 from "../assets/planos/peg/pm1.json"

import pve_pm1 from "../assets/planos/pve/pm1.json"
import pve_p1 from "../assets/planos/pve/p1.json"
import pve_p2 from "../assets/planos/pve/p2.json"

import poe_p1 from "../assets/planos/poe/p1.json"
import poe_p2 from "../assets/planos/poe/p2.json"
import poe_p3 from "../assets/planos/poe/p3.json"

import off_p1 from "../assets/planos/off/p0.json"
import off_p2 from "../assets/planos/off/p1.json"

import chi_pm1 from "../assets/planos/chi/pm1.json"
import chi_p1 from "../assets/planos/chi/p1.json"
import chi_p2 from "../assets/planos/chi/p2.json"
import chi_p3 from "../assets/planos/chi/p3.json"

// Setting the mall which to render. Options are pld, pve, poe, peg
let MALL_ID = "chi"
setMallId();

let PISO_1_INDEX = 0;
let START_VIEW = "start";
let MAP_VIEW = "map";

let pm1 = [], p0 = [], p1 = [], p2 = [], p3 = [], p4 = [];
let currentConf;

// Modo tótem (ver también StartView.js): con ?kiosk=1 el origen ('from')
// solo puede ser un lugar cuyo nombre contenga "entrada".
const KIOSK_MODE = gup("kiosk") === "1";
const ENTRANCE_MATCH = /entrada/i;

class App extends Component {
  constructor(props) {
    super(props);
    // If JA has content, then evaluate the building and load that config, adn hide the initial box setting the paras as initial value
    currentConf = config.filter(conf => conf.id === MALL_ID)[0];
    setMapTopOffset(currentConf.mapTopOffset);
    this.state = {
      start: false,
      end: false,
      context: false,
      stores: false,
      disccounts: false,
      currentFloor: PISO_1_INDEX,
      mode: START_VIEW,
      config: currentConf,
      to: '',
      from: ''
    };
    switch(currentConf.id){
      case "pld":
        document.title = "Mapa Interactivo - Mallplaza Los Dominicos";
        p0 = pld_p0;
        p1 = pld_p1;
        p2 = pld_p2;
        p3 = pld_p3;
        break;
      case "pve":
        document.title = "Mapa Interactivo - Mallplaza Vespucio";
        pm1 = pve_pm1;
        p1 = pve_p1;
        p2 = pve_p2;
      break;
      case "poe":
        document.title = "Mapa Interactivo - Mallplaza Oeste";
        p1 = poe_p1;
        p2 = poe_p2;
        p3 = poe_p3;
      break;
      case "peg":
        document.title = "Mapa Interactivo - Mallplaza Egaña";
        pm1 = peg_pm1;
        p0 = peg_p0;
        p1 = peg_p1;
        p2 = peg_p2;
        p3 = peg_p3;
        p4 = peg_p4;
      break;
      case "off":
        document.title = "Mapa Interactivo - Office";
        p0 = off_p1;
        p1 = off_p2;
      break;
      case "chi":
        document.title = "Mapa Interactivo - U de Chile";
        pm1 = chi_pm1;
        p1 = chi_p1;
        p2 = chi_p2;
        p3 = chi_p3;
      break;
      default:
        document.title = "Mapa Interactivo - Office";
        p0 = off_p1;
        p1 = off_p2;
      break;
    }
  }

  componentDidMount() {
    $("#mapview").css("display", "none");
    this.processStores();
    this.processDisccounts();

    const from = gup("from");
    const to = gup("to");
    if (from && to) {
      // Find the corresponding nodes for 'from' and 'to'
      const start = this.findNodeById(from);
      const end = this.findNodeById(to);

      if (start && (KIOSK_MODE ? ENTRANCE_MATCH.test(start.store_info.title) : true) && end) {
        // Call onSelectionFinished with the start and end nodes
        this.onSelectionFinished(start, end);
      } else {
        console.error("Invalid 'from' or 'to' parameters. Nodes not found.");
      }
    } else if (from) {
      // set the start node
      const start = this.findNodeById(from);
      if (start && (KIOSK_MODE ? ENTRANCE_MATCH.test(start.store_info.title) : true)) {
        this.setState({ start });
      } else {
        console.error("Invalid 'from' parameter. Node not found.");
      }
    } else if (to) {
      // set the end node
      const end = this.findNodeById(to);
      if (end) {
        this.setState({ end });
      } else {
        console.error("Invalid 'to' parameter. Node not found.");
      }
    }
  }

  processStores() {
    loadStores(currentConf.stores_url, (success, response) => {
      if (success) {
        let stores = response.tiendas;
        if (stores.length > 0) {
          let fm1 = [],
            f1 = [],
            f2 = [],
            f3 = [],
            f0 = [],
            f4 = []
          stores.forEach(s => {
            switch (s.nivel.trim()) {
              case "-1":
                f0.push(s);
                break;
              case "0":
                f0.push(s);
                break;
              case "1":
                f1.push(s);
                break;
              case "2":
                f2.push(s);
                break;
              case "3":
                f3.push(s);
                break;
              case "4":
                f4.push(s);
                break;
              default:
                //console.log(s);
                break;
            }
          });
          let stateStores = {
            fm1: fm1.sort((a, b) => a.title > b.title),
            f0: f0.sort((a, b) => a.title > b.title),
            f1: f1.sort((a, b) => a.title > b.title),
            f2: f2.sort((a, b) => a.title > b.title),
            f3: f3.sort((a, b) => a.title > b.title),
            f4: f4.sort((a, b) => a.title > b.title)
          };
          this.setState({
            stores: stateStores
          });
        }
      } else {
        alert("Ocurrió un error obteniendo las tiendas");
      }
    });
  }

  processDisccounts() {
    loadDisccounts( currentConf.disccounts_url, (success, response) => {
      if (success) {
        this.setState({
          disccounts: response.promociones_array
        });
      } else {
        alert("Ocurrió un error obteniendo los descuentos");
      }
    });
  }

  findNodeById(nodeId) {
    const allNodes = [...pm1, ...p0, ...p1, ...p2, ...p3, ...p4]; // Combine all floors
    return allNodes.find((node) => node.id === nodeId);
  }

  onSelectionFinished(start, end) {
    this.setState(state => ({
      start,
      end,
      routeKey: (state.routeKey || 0) + 1,
      mode: MAP_VIEW
    }));

    $("#startview").animateCss("fadeOut", () => {
      $("#startview").css("display", "none");
    });
    $("#mapview").css("display", "block");
    $("#mapview").animateCss("fadeIn");
  }

  onMapBack() {
    $("#startview").css("display", "block");
    $("#disccountscontainer").hide();
    $("#startview").animateCss("fadeIn", () => {});
    $("#mapview").animateCss("fadeOut", () => {
      $("#mapview").css("display", "none");
    });
  }

  render() {
    let { stores, start, end, disccounts, config } = this.state;
    return (
      <div id="app" className="App">
        <StartView
          config={config}
          stores={stores}
          start={start}
          end={end}
          pm1={pm1}
          p0={p0}
          p1={p1}
          p2={p2}
          p3={p3}
          p4={p4}
          onSelectionFinished={(start, end) =>
            this.onSelectionFinished(start, end)}
        />
        <MapView
          config={config}
          stores={stores}
          disccounts={disccounts}
          start={start}
          end={end}
          pm1={pm1}
          p0={p0}
          p1={p1}
          p2={p2}
          p3={p3}
          p4={p4}
          animate={start && end}
          onBack={() => this.onMapBack()}
          routeKey={this.state.routeKey}
          onServiceSelected={end =>
            this.setState(state => ({ end, routeKey: (state.routeKey || 0) + 1 }))}
        />
      </div>
    );
  }
}

$.fn.extend({
  animateCss: function(animationName, callback) {
    let animationEnd = (function(el) {
      let animations = {
        animation: "animationend",
        OAnimation: "oAnimationEnd",
        MozAnimation: "mozAnimationEnd",
        WebkitAnimation: "webkitAnimationEnd"
      };
      for (let t in animations) {
        if (el.style[t] !== undefined) {
          return animations[t];
        }
      }
    })(document.createElement("div"));
    this.addClass("animated " + animationName).one(animationEnd, function() {
      $(this).removeClass("animated " + animationName);

      if (typeof callback === "function") callback();
    });
    return this;
  }
});
export default App;

function setMallId(){
  var mallId = gup("building");
  if(mallId === "pld" || mallId === "pve" || mallId === "peg" || mallId === "poe" || mallId === "off" || mallId === "chi") {
    MALL_ID = mallId;
  } else {
    console.log("Building not found")
  }
}

/**
 * https://stackoverflow.com/a/979997/2026902
 */
function gup(name) {
  var url = window.location.href;
  name = name.replace(/[\[]/,"\\\[").replace(/[\]]/,"\\\]");
  var regexS = "[\\?&]"+name+"=([^&#]*)";
  var regex = new RegExp( regexS );
  var results = regex.exec( url );
  return results == null ? null : results[1];
}

/**
 * Object.prototype.forEach() polyfill
 * https://gomakethings.com/looping-through-objects-with-es6/
 * @author Chris Ferdinandi
 * @license MIT
 */
if (!Object.prototype.forEach) {
	Object.defineProperty(Object.prototype, 'forEach', {
		value: function (callback, thisArg) {
			if (this == null) {
				throw new TypeError('Not an object');
			}
			thisArg = thisArg || window;
			for (var key in this) {
				if (this.hasOwnProperty(key)) {
					callback.call(thisArg, this[key], key, this);
				}
			}
		}
	});
}



// WEBPACK FOOTER //
// ./src/App.js